// frontend/src/config/adsConfig.js
export const ads = [
  {"image":"ad_shimano.jpeg",
  "link":"https://www.shimano.com/",
  },
  {"image":'ad_oneup.png',
  'link':'https://www.oneupcomponents.com/',
  },
  {"image":'ad_mondraker.png',
  'link':'https://www.mondraker.com/',
  },
  {"image":'ad_tld.png',
  'link':'https://troyleedesigns.com/',
  }
];
